import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useMediaQuery, useTheme } from '@mui/material';

import EditUserHeader from './EditUserHeader';
import EditUserContext from '../context/EditUserContext';
import EditUserTabContent from './EditUserTabContent';
import useEditUser from '@/operator/graphql/hooks/users/useEditUser';
import EditUserSkeleton from '../Skeleton/EditUserFormSkeleton';

const EditUser: React.FC = () => {
    const { id } = useParams();

    const [selectedTab, setSelectedTab] = useState(0);

    const theme = useTheme();

    const stackOrientation: 'horizontal' | 'vertical' = useMediaQuery(
        theme.breakpoints.up('lg'),
    )
        ? 'vertical'
        : 'horizontal';

    const handleOnChangeTab = (
        _event: React.SyntheticEvent,
        newTab: number,
    ) => {
        setSelectedTab(newTab);
    };

    const contextValue = useEditUser(id);

    return (
        <div style={{ width: '100%' }}>
            <EditUserHeader />
            <EditUserContext.Provider value={contextValue}>
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={2}>
                        <Tabs
                            variant="scrollable"
                            orientation={stackOrientation}
                            onChange={handleOnChangeTab}
                            value={selectedTab}
                        >
                            <Tab label="Basic Information" value={0} />
                            <Tab label="Roles" value={1} />
                        </Tabs>
                    </Grid>
                    <Grid item xs={12} lg={10} paddingRight={3}>
                        {contextValue.loading ? (
                            <EditUserSkeleton />
                        ) : (
                            <EditUserTabContent selectedTab={selectedTab} />
                        )}
                    </Grid>
                </Grid>
            </EditUserContext.Provider>
        </div>
    );
};

export default EditUser;
